<template>
  <div id="schedule">
    <transition name="fade">
      <b-row class="mt-4" v-if="show">
        <b-col class="px-5">
          <!-- Scelta strumento -->
          <b-card
            title="Su quale strumento desideri essere informato?"
            v-if="currentStep(0) && schedule.category === 'Tutor' "
            class="mb-3 py-2 px-3">

            <ul class="list-inline my-5">
              <li
                v-for="(prop, key) in services" :key="prop.name"
                v-bind:class="{ active: key === schedule.product }"
                @click="schedule.product=key"
                class="list-inline-item step1-list-item px-4 py-2 text-center">
                <img :src="`/static/img/collaboration/${prop.icon}`" :alt="key" class="img img-fluid m-2"/>
                <br>
                {{ prop.name }}
              </li>
            </ul>

            <div class="mt-3">
              <b-btn variant="success" @click="nextStep">Avanti</b-btn>
              <b-btn variant="outline-default" @click="show=false">Indietro</b-btn>
            </div>
          </b-card>

          <b-card
            title="Da quale sistema vuoi migrare i tuoi dati?"
            v-if="currentStep(0) && schedule.category === 'Collaboration' "
            class="mb-3 py-2 px-3">

            <ul class="list-inline my-5">
              <li
                v-for="(prop, key) in collaborationServices" :key="prop.name"
                v-bind:class="{ active: key === schedule.product }"
                @click="schedule.product=key"
                class="list-inline-item step1-list-item px-4 py-2 text-center">
                <img :src="`/static/img/collaboration/${prop.icon}`" :alt="key" class="img img-fluid m-2"/>
                <br>
                {{ prop.name }}
              </li>
            </ul>

            <div class="mt-3">
              <b-btn variant="success" @click="nextStep">Avanti</b-btn>
              <b-btn variant="outline-default" @click="show=false">Indietro</b-btn>
            </div>
          </b-card>

          <!-- Informazioni secondarie -->
          <b-card
            title="Tematiche di interesse"
            v-if="currentStep(1) && schedule.category === 'Tutor'"
            class="mb-3 py-2 px-3">
            <p class="mt-3 mb-2">Indicati una o più tematiche di interesse</p>

            <multiselect
              v-model="schedule.options"
              :options="services[schedule.product].options"
              :multiple="true"
              :close-on-select="false"
              placeholder="Seleziona una o più voci"
              class="mb-3"/>

            <p class="mt-3 mb-2">Hai esigenze particolari?</p>
            <b-form-textarea
              v-model="schedule.customer_notes"
              placeholder="Inserisci le tue note aggiuntive"
              :rows="5" :max-rows="5">
            </b-form-textarea>

            <div class="mt-3">
              <b-btn variant="success" @click="nextStep">Avanti</b-btn>
              <b-btn variant="outline-default" @click="prevStep">Indietro</b-btn>
            </div>
          </b-card>

          <b-card
            title="Verso quale sistema vuoi migrare i tuoi dati?"
            v-if="currentStep(1) && schedule.category === 'Collaboration' "
            class="mb-3 py-2 px-3">

            <ul class="list-inline my-5">
              <li
                v-for="(prop, key) in collaborationServices" :key="prop.name"
                v-bind:class="{ active: key === schedule.product_dest }"
                @click="schedule.product_dest=key"
                class="list-inline-item step1-list-item px-4 py-2 text-center">
                <img :src="`/static/img/collaboration/${prop.icon}`" :alt="key" class="img img-fluid m-2"/>
                <br>
                {{ prop.name }}
              </li>
            </ul>

            <div class="mt-3">
              <b-btn variant="success" @click="nextStep">Avanti</b-btn>
              <b-btn variant="outline-default" @click="show=false">Indietro</b-btn>
            </div>
          </b-card>


          <!-- scelta data -->
          <b-card
            title="Quando vuoi essere ricontattato?"
            v-if="currentStep(2)"
            class="mb-3 py-2 px-3">
            <p class="mt-5">Scegli il giorno</p>
            <ul class="list-inline mt-2 mb-5">
              <li class="list-inline-item text-center">
                <btn @click="prevWeek" class="my-5 mx-3">
                  <h1><i class="fas fa-chevron-circle-left my-3 text-secondary"></i></h1>
                </btn>
              </li>
              <li
                v-for="day in calendarDays"
                v-bind:class="{ active: day.isSame(schedule.day) }"
                @click="schedule.day = day"
                class="list-inline-item step2-list-item text-center">
                <small class="font-size-12">{{ day | moment('dddd') | capitalize }}</small>
                <h1> {{ day | moment('DD')}} </h1>
                <small class="font-size-14">{{ day | moment('MMMM') | uppercase }}</small>
              </li>
              <li class="list-inline-item text-center">
                <btn @click="nextWeek" class="my-5 mx-3">
                  <h1><i class="fas fa-chevron-circle-right my-3 text-secondary font-size-18"></i></h1>
                </btn>
              </li>
            </ul>

            <p class="mt-5">Scegli l'ora</p>
            <ul class="list-inline mt-2 mb-5">
              <li
                v-for="h in hours"
                v-bind:class="{ active: h === schedule.hour }"
                @click="schedule.hour = h"
                class="list-inline-item step2-list2-item text-center">{{ h }}
              </li>
            </ul>

            <div class="mt-3">
              <b-btn variant="success" @click="nextStep">Avanti</b-btn>
              <b-btn variant="outline-default" @click="prevStep">Indietro</b-btn>
            </div>
          </b-card>

          <!-- scelta ricontatti -->
          <b-card
            title="Come vuoi essere ricontattato?"
            v-if="currentStep(3)"
            class="mb-3 py-2 px-3">
            <b-row>
              <b-col cols="8">
                <p class="mt-3 mb-2">Numero di telefono</p>
                <b-form-input
                  v-model="schedule.phone_number"
                  type="tel"
                  placeholder="Inserisci il tuo numero di telefono"/>

                <p class="mt-3 mb-2">Indirizzo email</p>
                <b-form-input
                  v-model="schedule.email"
                  type="email"
                  placeholder="Inserisci il tuo indirizzo email"/>
              </b-col>
            </b-row>


            <div class="mt-5">
              <b-btn variant="success" @click="nextStep" :disabled="!schedule.phone_number || !schedule.email">
                Avanti
              </b-btn>
              <b-btn variant="outline-default" @click="prevStep">Indietro</b-btn>
            </div>
          </b-card>

          <!-- riepilogo -->
          <b-card
            title="Riepilogo"
            v-if="currentStep(4)"
            class="mb-3 py-2 px-3">

            <b-row class="mt-3">
              <b-col cols="1" class="text-center">
                <img :src="`/static/img/collaboration/${services[schedule.product].icon}`" class="img img-responsive"/>
              </b-col>
              <b-col cols="3">
                Strumento<br>
                <h4><strong>{{ services[schedule.product].name }}</strong></h4>
              </b-col>

              <b-col cols="1" v-if="schedule.category === 'Collaboration'">
                <img src="../../assets/icons/icn-arrows-right.svg" class="my-3 img img-responsive" />
              </b-col>
              <b-col cols="1" class="text-center" v-if="schedule.category === 'Collaboration'">
                <img :src="`/static/img/collaboration/${services[schedule.product_dest].icon}`" class="img img-responsive"/>
              </b-col>
              <b-col cols="3" v-if="schedule.category === 'Collaboration'">
                Strumento destinazione<br>
                <h4><strong>{{ services[schedule.product_dest].name }}</strong></h4>
              </b-col>

            </b-row>

            <b-row class="mt-3" v-if="schedule.category === 'Tutor'">
              <b-col>
                <p>Tematiche di interesse</p>

                <h3>
                  <b-badge v-for="value in schedule.options" :key="value" variant="success" class="mr-2">{{ value }}</b-badge>
                </h3>

              </b-col>
            </b-row>

            <b-row class="mt-3" v-if="schedule.category === 'Tutor'">
              <b-col>
                <p>Esigenze particolari</p>
                <p>
                  <strong>{{ schedule.customer_notes | nl2br | placeholder('Nessuna nota inserita') }}</strong>
                </p>
              </b-col>
            </b-row>

            <b-row class="mt-3">
              <b-col>
                <p>Contatti</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="4">
                <h4><i class="fas fa-phone mr-2 text-secondary"></i> {{ schedule.phone_number }}</h4>
              </b-col>
              <b-col>
                <h4><i class="far fa-envelope mr-2 text-secondary"></i> <strong>{{ schedule.email }}</strong></h4>
              </b-col>
            </b-row>

            <b-row class="mt-3">
              <b-col>
                <p>Appuntamento</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="4">
                <h4><i class="far fa-calendar-alt mr-2"></i> {{ schedule.day | moment('dddd DD MMMM') }}</h4>
              </b-col>
              <b-col>
                <h4><i class="far fa-clock mr-2 text-secondary"></i> <strong>{{ schedule.hour }}:00</strong></h4>
              </b-col>
            </b-row>


            <div class="mt-5">
              <b-btn variant="warning" @click="sendRequest" size="lg">INVIA RICHIESTA</b-btn>
              <b-btn variant="outline-default" @click="prevStep">Indietro</b-btn>
            </div>
          </b-card>

          <!-- success box -->
          <b-card
            bg-variant="primary"
            v-if="success"
            class="mb-3 py-2 px-3">

            <b-btn variant="link" class="float-right text-white" @click="success=false; show=false"><i class="fas fa-times"></i></b-btn>

            <b-row>
              <b-col cols="3" align-v="center">
                <img src="../../assets/icons/illo-confirm.svg" class="my-5"/>
              </b-col>
              <b-col class="text-white" align-v="center">
                <h1 class="mt-3">Grazie {{ schedule.name }},</h1>

                <h3 v-if="schedule.category === 'Tutor'">
                  La tua sessione di formazione su <strong><u>{{ services[schedule.product].name }}</u></strong>
                  è stata confermata per il giorno <strong><u>{{ schedule.day | moment('dddd DD MMMM') }}</u></strong>
                  alle ore <strong><u>{{ schedule.hour }}:00</u></strong>.
                </h3>
                <h3 v-else>
                  La tua migrazione da <strong><u>{{ services[schedule.product].name }}</u></strong>
                  verso <strong><u>{{ services[schedule.product_dest].name }}</u></strong>
                  è stata confermata per il giorno <strong><u>{{ schedule.day | moment('dddd DD MMMM') }}</u></strong>
                  alle ore <strong><u>{{ schedule.hour }}:00</u></strong>.
                </h3>

                <add-to-calendar
                  :title="eventTitle"
                  :start="eventStart"
                  :end="eventEnd"
                  class="mt-5 mb-2"
                  inline-template>
                  <div>
                    <google-calendar id="google-calendar" class="btn btn-outline-light">
                      <i class="fab fa-google mr-2"></i> Aggiungi a Google Calendar
                    </google-calendar>

                    <microsoft-calendar id="microsoft-calendar" class="btn btn-outline-light">
                      <i class="fab fa-microsoft mr-2"></i> Aggiungi a Live Calendar
                    </microsoft-calendar>
                  </div>
                </add-to-calendar>
              </b-col>
            </b-row>

          </b-card>
        </b-col>
      </b-row>
    </transition>
  </div>
</template>

<script>
  import EventBus from '@/services/eventbus';
  import moment from 'moment';
  import _ from 'lodash';
  import Multiselect from 'vue-multiselect'

  export default {
    name: 'Schedule',
    components: {
      Multiselect,
    },
    data: () => ({
      step: 0,
      show: false,
      success: false,
      ticket_id: null,
      week: 0,
      hours: ['09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19'],
      schedule: {
        type: 'Assistenza',
        category: null,
        subcategory: null,
        phone_number: null,
        email: null,
        onsite: false,
        product: 'google',
        product_dest: 'google',
        options: [],
        day: null,
        hour: null,
        customer_notes: '',
        name: '',
        subscription_id: null,
      },

      services: {
        google: {
          name: 'G Suite',
          icon: 'google.svg',
          options: ['Gmail', 'Calendar', 'Google+', 'Hangout Chat', 'Hangout Meet', 'Documenti', 'Fogli', 'Moduli', 'Presentazioni', 'Sites', 'Keep', 'Drive', 'Google Cloud Search', 'Vault']
        },
        office365: {
          name: 'Office 365',
          icon: 'office.svg',
          options: ['Outlook', 'Onedrive', 'Word', 'Excel', 'Powerpoint', 'Onenote', 'Sharepoint', 'Teams', 'Staffhub', 'PowerApps', 'Forms', 'Delve', 'Dinamics365'],
        },
        microsoft365: {
          name: 'Microsft 365',
          icon: 'microsoft_365.svg',
          options: ['Office applications', 'Collaboration services', 'Business Applications', 'Security', 'Device Management'],
        },
        microsoft_ems: {
          name: 'Microsft EMS',
          icon: 'microsoft.svg',
          options: ['Azure Active Directory', 'Azure Information Protection', 'Microsoft Intune', 'Microsoft Cloud App Security', 'Microsoft Advanced Threat Analytics', 'Microsoft Identity Manager', 'Azure Advanced Threat Protection'],
        },
      }
    }),

    computed: {
      collaborationServices() {
        return {
          google: this.services.google,
          office365: this.services.office365,
        }
      },
      calendarDays() {
        moment.locale('it');
        const max_days = 5;
        const days = [];

        const m = moment().add(1 +(this.week*7), 'day').startOf('day');
        days.push(m.clone()); // add first day

        while (days.length < max_days) {
          m.add(1, 'day');

          // escludo sabato e domenica
          if (m.format('e') !== "5" && m.format('e') !== "6")
            days.push(m.clone());
        }
        return days;
      },

      eventTitle() {
        return `Skillo ${this.schedule.category} - ${this.schedule.subcategory}`;
      },

      eventStart() {
        const m = moment(this.schedule.day);
        m.set('hour', this.schedule.hour);

        return m;
      },
      eventEnd() {
        const m = moment(this.schedule.day);
        m.set('hour', this.schedule.hour);
        m.add(2, 'hours');

        return m;
      }
    },

    mounted() {
      EventBus.$on('schedule', this.onSchedule);
      EventBus.$on('reschedule', this.onReschedule);
    },

    methods: {
      onSchedule(data) {
        this.ticket_id = null;
        this.show = true;
        this.success = false;
        this.step = 0;
        this.product = 'google';
        this.product_dest = 'google';
        this.schedule.category = data.category;
        this.schedule.subcategory = data.subcategory;
        this.schedule.email = data.email;
        this.schedule.name = data.name;
        this.schedule.subscription_id = data.subscription_id;
        this.schedule.phone_number = data.phone_number;
        this.schedule.customer_notes = '';
        this.schedule.options = [];
        this.schedule.day = moment().add(1, 'day').startOf('day');
        this.schedule.hour = '09';
      },

      onReschedule(data) {
        let now = moment();
        let day;

        if(data.day.isBefore(now)) {
          day = moment().add(1, 'day').startOf('day');
        } else {
          day = data.day;
        }

        this.ticket_id = data.id;
        this.show = true;
        this.step = 0;
        this.success = false;
        this.schedule.product = data.product;
        this.schedule.product_dest = data.product_dest;
        this.schedule.category = data.category;
        this.schedule.subcategory = data.subcategory;
        this.schedule.email = data.email;
        this.schedule.name = data.name;
        this.schedule.subscription_id = null;
        this.schedule.phone_number = data.phone_number;
        this.schedule.customer_notes = data.customer_notes;
        this.schedule.options = data.options;
        this.schedule.day = day;
        this.schedule.hour = data.hour;
      },

      currentStep(step) {
        return this.step === step
      },

      nextStep() {
        this.step += 1;
      },

      prevStep() {
        if (!this.step) return;
        this.step -= 1;
      },
      nextWeek() {
        if(this.week >8) return;
        this.week += 1;
      },
      prevWeek() {
        if (!this.week) return;

        this.week -= 1;
      },

      async sendRequest() {
        // confirmation box
        const confirm = await this.$swal({
          title: "Procedere con l'invio?",
          text: "Procedendo, la richiesta verrà inviata e processata dal nostro back-office.",
          icon: "warning",
          buttons: ["Indietro", "INVIA RICHIESTA"],
        });

        if (!confirm) return;

        this.schedule.schedule_date = moment(this.schedule.day);
        this.schedule.schedule_date.set('hour', this.schedule.hour);
        let loader = this.$loading.show();

        try {
          if (this.ticket_id)
            await this.$apiclient.updateTicket(this.ticket_id, this.schedule);
          else
            await this.$apiclient.createTicket(this.schedule);

          this.nextStep();
          this.success = true;

          loader.hide();
          EventBus.$emit('refresh_data');
        } catch(err) {
          await this.$swal("Errore Invio richiesta", err.message, "error");
          loader.hide();
          console.log(err);
        }

      }
    },
  };

</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
  .btn {
    border-radius: 0.6rem;
  }

  .card {
    box-shadow: 0 3px 20px rgba(0, 0, 0, 0.1);
  }

  .step1-list-item {
    border: 1px solid #ccc;
    min-height: 160px;
    min-width: 160px;
    cursor: pointer;
  }

  .step1-list-item img {
    height: 96px;
    width: 96px;
  }

  .step2-list-item {
    border: 1px solid #ccc;
    padding: 16px 48px;
    cursor: pointer;
  }

  .step2-list2-item {
    border: 1px solid #ccc;
    padding: 0 16px;
    font-size: 2rem;
    cursor: pointer;
  }

  .step2-list-item h1 {
    font-size: 4rem;
  }

  .active {
    background-color: hsla(207, 89%, 44%, 0.1);
    border: solid 2px hsl(207, 89%, 44%);
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

</style>



// WEBPACK FOOTER //
// src/components/plans/Schedule.vue